<ng-template [ngxPermissionsOnly]="['contacts:can_get_contacts_reports_income_per_contact']">
  <div class="box-row panel panel-default">
    <div class="panel-body text-center text-alpha">
      <div *ngIf="!isCountLoaded" class="whirl standard spinnermargin"></div>
      <ng-template [ngIf]="isCountLoaded">
        <div class="text-lg mo">{{contactsAverageIncome.income_per_lead | currency:contactsAverageIncome.currency_code: contactsAverageIncome.currency_precision}}</div>
        <p>Avg Revenue per Lead</p>
        <div class="mb-lg"></div>
      </ng-template>
    </div>
  </div>
</ng-template>